export default {
  products: [
    {
      id: 'p001',
      title: 'PP-Gig-bag',
      subTitle: "Tinner's House",
      category: 'Bags',
      price: '$10 ~ $30',
      pics: ['p001.jpg', 'p002.jpg', 'c3.png'],
      specs: {
        'Weight': '300g',
        'Matirial': 'PP',
        'Style': 'Freedom',
        'Height': '60px',
        'Col': 'Duroo Fiell',
        'Folu': 'Tested'
      },
      discriptions: 'Img elements must have an alt prop, either with meaningful text, or an empty string for decorative images.',
      packaging_shipping: 'FOB NingBo'
    },
    {
      id: 'p002',
      title: 'PP-Gig-bag222222',
      pics: ['p001.jpg', 'p002.jpg', 'c3.png'],
      specs: {
        'Weight': '300444g',
        'Matirial': 'PP222',
        'Style': 'Freedom222'
      },
      discriptions: 'Img elements must have an alt prop, either with meaningful text, or an empty string for decorative images.',
      packaging_shipping: 'FOB NingBo'
    }
  ]
}


// WEBPACK FOOTER //
// ./src/pages/home/components/product-detail/data.js